/**
* @name: page-menu-bg-set
* @author: weiyong
* @date: 2023-03-31 20:45
* @description：page-menu-bg-set
* @update: 2023-03-31 20:45
*/
<template>
  <div :class="prefixCls" class="themeAttr-item">
    <span class="themeAttr-item-title">{{t('菜单设置')}}</span>
    <div class="themeAttr-item-body flex-div">

      <use-sel-color ref="useSelCtrl" style="padding-right: 0;width:102px;" @closeOtherColor="closeOtherColor" @selItem="selItem"/>

      <div class="layout-item" @click="selItem(item)"
           :class="item.id===activeKey?'active':''" v-for="item in layoutAry">
        <div class="item-type-sign">
          <div class="color-div"
               :style="{ backgroundColor: item.id }"></div>
          <span class="layoutItem-type-sign-cuntermark"></span>
          <span class="layoutItem-type-sign-icon"><check-outlined/></span>
        </div>
      </div>
    </div>


    <div class="flex-wrap flex-div w100b">
      <div class="switch-item" style="margin-top: 12px;margin-right:10px" v-if="useLayout==='military'">
        <div class="switch-label" style="margin-bottom: 6px">{{t('显示浅色背景图')}}</div>
        <a-switch @change="(checked)=>{change(HandlerEnum.MENU_BG_IMG,checked)}"  v-model:checked="getMenuBgImg" />
      </div>

      <div class="switch-item" style="margin-top: 12px;margin-right:10px" v-if="useLayout==='military'">
        <div class="switch-label" style="margin-bottom: 6px">{{t('显示红色背景图')}}</div>
        <a-switch @change="(checked)=>{change(HandlerEnum.MENU_BG_IMG_RED,checked)}"  v-model:checked="getMenuBgImgRed" />
      </div>

      <div class="switch-item" style="margin-top: 12px;margin-right:10px" v-if="useLayout==='defaultFrameCom'">
        <div class="switch-label" style="margin-bottom: 6px">{{t('显示菜单查询')}}</div>
        <a-switch @change="(checked)=>{change(HandlerEnum.MENU_QUERY,checked)}"  v-model:checked="getMenuQuery" />
      </div>

      <div class="switch-item" style="margin-top: 12px"  v-if="useLayout==='defaultFrameCom'">
        <div class="switch-label" style="margin-bottom: 6px">{{t('显示菜单收藏')}}</div>
        <a-switch @change="(checked)=>{change(HandlerEnum.MENU_COLLECT,checked)}"  v-model:checked="getMenuCollect" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  components: {},
  name: "page-menu-bg-set",
});
</script>

<script lang="ts" setup>
import {Switch as ASwitch} from "ant-design-vue";
import UseSelColor from "@/views/dashboard/analysisSet/components/use-sel-color.vue";
import {CheckOutlined} from "@ant-design/icons-vue";
import {useDesign} from "@/hooks/web/useDesign";
import {baseHandler, handler} from "@/layouts/default/setting/handler";
import {HandlerEnum} from "@/layouts/default/setting/enum";
import {unref} from "vue";
import {useMenuSetting} from "@/hooks/setting/useMenuSetting";
import {useI18n} from "vue-i18n";

const propsPage=defineProps({
  useLayout:{}
})
const { t } = useI18n();
const {
  getMenuQuery,
  getMenuCollect,
  getMenuBgColor,
  getMenuBgImg,
  getMenuBgImgRed,
} = useMenuSetting();

const emits = defineEmits(['closeOtherColor'])
const layoutAry = [
  {id: '#001529', color: '#001529'},
  {id: '#212121', color: '#212121'},
  {id: '#273352', color: '#273352'},
  {id: '#ffffff', color: '#ffffff'},
  {id: '#191b24', color: '#191b24'},
  {id: '#191a23', color: '#191a23'},
  {id: '#065979', color: '#065979'},
  {id: '#304156', color: '#304156'},
  {id: '#001628', color: '#001628'},
  {id: '#28333E', color: '#28333E'},
  {id: '#344058', color: '#344058'},
  {id: '#1BA57C', color: '#1BA57C'},
  {id: '#1F58A7', color: '#1F58A7'},
];

const {prefixCls} = useDesign('page-menu-bg-set');
const activeKey = ref(unref(getMenuBgColor));

const selItem = function (item) {
  activeKey.value = item.id;
  baseHandler(HandlerEnum.MENU_THEME, item.id)
}

const useSelCtrl:any= ref(null);
const closePanel=function (){
  useSelCtrl.value.closePanel();
}
defineExpose({closePanel, selItem})

const closeOtherColor=function (){
  emits('closeOtherColor', {});
}


const change=function (event,val){
  baseHandler(event, val)
}

</script>

<style type="text/css" lang="less">
@prefix-cls: ~'@{namespace}-page-menu-bg-set';

.@{prefix-cls} {
  width: 100%;
  padding: 16px;
  margin-bottom: 10px;
  border-radius: 6px;
  background: #fff;
  font-family: PingFangSC-Semibold, PingFang SC;

  .themeAttr-item-body {
    flex-wrap: wrap;
  }

  .layout-item {
    position: relative;
    cursor: pointer;

    .color-div {
      border: 1px solid #dfdfdf;
      width:32px;height:32px;border-radius: 4px;
    }

    &.active {
      .item-type-sign {
        border: 1px solid #ff2121;
      }

      .layoutItem-type-sign-cuntermark {

        border-color: #ff2121 #ff2121 transparent transparent;
      }

      .layoutItem-type-sign-icon {
        color: #fff;
      }
    }

    .layoutItem-type-sign-icon {
      position: absolute;
      top: -1px;
      right: 0.5px;
      width: 20px;
      height: 20px;
      font-size: 9px;
      z-index: 2;
      color: transparent;
      font-weight: bold;
    }

    .layoutItem-type-sign-cuntermark {
      position: absolute;
      top: 0;
      right: 13px;
      width: 16px;
      height: 16px;
      border: 8px solid transparent;
      z-index: 1;
    }
  }

  .themeAttr-item-title {
    display: block;
    font-size: 14px;
    font-weight: 600;
    color: #111;
    margin-bottom: 14px;
  }

  .itme-title-span {
    text-align: center;
    margin-top: 6px;
  }

  .item-type-sign {
    width: 40px;
    height: 40px;
    padding: 3px;
    border: 1px solid #fff;
    border-radius: 3px;
    margin-right: 12px;
  }
}
</style>
